export enum FeedbackTypeEnum {
    Positive = "up",
    Negative = "down",
}
